import React from 'react'
import Register from '@/pages/register/register'

interface Props{}
// 领取额度
const getLimit:React.FC<Props> = () => {
  return (
    <Register type="getLimit" />
  )
}

export default getLimit